import axios from 'axios'
import auth from '@/store/modules/auth'
import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_UTILITY + '/interest'

const addMultipleInterest = (params) => {
  return axios.put(baseURL + `/add?vendorId=${auth.state.auth.vendorId}`,
    params)
}

const fetch = (params) => {
  return Repository(baseURL).fetch(params)
}

export default {
  addMultipleInterest,
  fetch
}
